const Download = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M1 14.5v2.25A2.25 2.25 0 0 0 3.25 19h13.5A2.25 2.25 0 0 0 19 16.75V14.5M14.5 10 10 14.5m0 0L5.5 10m4.5 4.5V1"
		/>
	</svg>
);
export default Download;
